/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { toImageUrl } from "../../../../../utils/formatHelper";
import { getUserById } from "../../../../../api/userApi";
import { axiosAuthInstance } from "../../../../../axios/auth.axios";

export function UserProfileDropdown() {
    const user = JSON.parse(localStorage.getItem("user"));
    const controllerRef = useRef(null);

    const [userById, setUserById] = useState({});

    const fetchUserById = useCallback(
        async signal => {
            try {
                const _user = await getUserById(user?.id, signal);
                if (_user) {
                    setUserById(_user);
                }
            } catch (error) {
                console.dir(error);
            }
        },
        [user.id],
    );

    // logout
    const logout = async () => {
        await axiosAuthInstance.get("auth/logout");
        localStorage.clear();
        window.location.reload();
    };

    // memo
    const userImagePathMemo = useMemo(() => {
        const path = userById?.imagePath?.slice(0, 5);
        return userById?.imagePath
            ? path !== "https"
                ? toImageUrl(userById?.imagePath)
                : userById?.imagePath
            : toAbsoluteUrl("/media/HCH/users/empty_img.png");
    }, [userById]);

    // run only first render
    useEffect(() => {
        controllerRef.current = new AbortController();
        // fetch on component mounted
        const fetch = async () => {
            await fetchUserById(controllerRef.current?.signal);
        };
        fetch();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, [fetchUserById]);

    const uiService = useHtmlClassService();
    const layoutProps = useMemo(() => {
        return {
            light: objectPath.get(uiService.config, "extras.user.dropdown.style") === "light",
        };
    }, [uiService]);

    return (
        <Dropdown drop="down" alignRight>
            <Dropdown.Toggle as={DropdownTopbarItemToggler} id="dropdown-toggle-user-profile">
                <div
                    className={"btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"}
                    style={{ width: "100%" }}>
                    <div
                        className="symbol symbol-30 symbol-lg-30 symbol-circle mr-3"
                        // style={{ border: "1px solid #000000" }}
                    >
                        <img src={userImagePathMemo} alt="logo" />
                    </div>
                    <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
                        {userById?.username}
                    </span>
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
                <>
                    {/** ClassName should be 'dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
                    {layoutProps.light && (
                        <>
                            <div className="d-flex align-items-center p-8 rounded-top">
                                <div className="symbol symbol-md bg-light-primary mr-3 flex-shrink-0">
                                    <img src={userImagePathMemo} alt="profile" />
                                </div>
                                <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5">{userById?.fullname}</div>
                            </div>
                            <div className="separator separator-solid"></div>
                        </>
                    )}

                    {!layoutProps.light && (
                        <div
                            className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
                            style={{
                                backgroundImage: `url(${toAbsoluteUrl("/media/misc/bg-1.jpg")})`,
                            }}>
                            <div className="symbol bg-white-o-15 mr-3">
                                <span className="symbol-label text-success font-weight-bold font-size-h4">
                                    <img src={userImagePathMemo} alt="profile" width={43} />
                                </span>
                            </div>
                            <div className="text-white m-0 flex-grow-1 mr-3 font-size-h5">{userById?.fullname}</div>
                        </div>
                    )}
                </>

                <div className="navi navi-spacer-x-0 pt-5">
                    <a className="navi-item px-8">
                        <div className="navi-link">
                            <div className="navi-icon mr-2">
                                <i className="flaticon2-mail text-warning"></i>
                            </div>
                            <div className="navi-text">
                                <div className="font-weight-bold">My Messages</div>
                                <div className="text-muted">Inbox and tasks</div>
                            </div>
                        </div>
                    </a>

                    <a className="navi-item px-8">
                        <div className="navi-link">
                            <div className="navi-icon mr-2">
                                <i className="flaticon2-rocket-1 text-danger"></i>
                            </div>
                            <div className="navi-text">
                                <div className="font-weight-bold">My Activities</div>
                                <div className="text-muted">Logs and notifications</div>
                            </div>
                        </div>
                    </a>

                    <a className="navi-item px-8">
                        <div className="navi-link">
                            <div className="navi-icon mr-2">
                                <i className="flaticon2-hourglass text-primary"></i>
                            </div>
                            <div className="navi-text">
                                <div className="font-weight-bold">My Tasks</div>
                                <div className="text-muted">latest tasks and projects</div>
                            </div>
                        </div>
                    </a>
                    <div className="navi-separator mt-3"></div>

                    <div className="navi-footer  px-8 py-5">
                        <div onClick={logout} className="btn btn-light-danger font-weight-bold">
                            Sign Out
                        </div>
                    </div>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}
